<!-- Property of OSF Global Services, Inc., (with its brand OSF Commerce). OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein. -->
<style lang="scss" scoped="scoped">
@media (min-width: 768px) {
    .navbuttons {
        display: none;
    }
}
#buttonsWrapper {
    position: relative;
    display: flex;
    justify-content: center;
    padding: 1rem 3rem;
    background-color: #000;
    color: #fff;
    flex-wrap: wrap;
    border-bottom: 0.0625rem solid #fff;
}
.title {
    letter-spacing: 1.2px;
}
.prev-button {
    position: absolute;
    left: 1rem;
    top: 50%;
    transform: translateY(-50%);
    background-color: transparent;
    border: 0;
}
.next-button {
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
    background-color: transparent;
    border: 0;

    &.disabled {
        display: none;
    }
}
.progress-bar {
    width: 100%;
    height: 0.25rem;
    background-color: rgba(0, 0, 0, 0.4);
    position: relative;
}
.progress-bar:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 0.25rem;
    background-color: #fff;
    width: calc(100vw * var(--currentStepPosition) / var(--nbSteps));
    z-index: 1;
}
.progress-bar.light {
    border-bottom: 0.0625rem solid #fff;
}
.progress-bar.light:before {
    background-color: #000;
}
</style>

<template>
    <div
        v-if="this.question.renderTemplate === 'Template9'"
        class="navbuttons"
        v-bind:class="{ hidden: this.isHidden }"
    />
    <div v-else class="navbuttons">
        <div
            class="progress-bar"
            :class="[this.question.renderTemplate === 'Template6' ? 'light' : '']"
            :style="progressBarStyle"
        ></div>
        <!-- Quiz Navigation Buttons Component for mobile -->
        <div id="buttonsWrapper" v-bind:class="{ disabled: this.isAnswerMax }">
            <!-- Previous Button -->
            <button
                v-if="quizData.navBtns"
                class="prev-button"
                v-on:click="prevQuestion"
                :aria-label="this.question.prevQuestion.title"
            >
                <img :src="images.prev" :alt="this.question.prevQuestion.title" />
            </button>
            <!-- Question Title -->
            <div class="title ti-fs-16 mb-0">
                {{ this.isResultsPage ? this.stepSelectionText : this.question.stepTitle }}
            </div>
            <!-- Next Button -->
            <button
                v-if="!this.isResultsPage && quizData.navBtns"
                class="next-button"
                v-bind:class="{ disabled: this.nextButtonDisabled }"
                v-on:click="skipQuestion"
                :aria-label="this.question.nextQuestion.title"
            >
                <img :src="images.next" :alt="this.question.nextQuestion.title" />
            </button>
        </div>
    </div>
</template>

<script>
import { forIn } from "lodash";

export default {
    name: "NavigationButtons",
    props: { isResultsPage: Boolean },
    computed: {
        question: function () {
            return this.$store.state.questionData;
        },
        quizData: function () {
            return this.$store.state.quizData;
        },
        nextButtonDisabled: function () {
            return this.$store.state.nextDisabled && !this.question.skippable;
        },
        isHidden: function () {
            return this.$store.state.isHidden;
        },
        nextAnswered: function () {
            let curentIndex = this.$store.state.stepData.titles.map((item) => item.current).indexOf(true);
            let nextIndex = curentIndex + 1;

            if (nextIndex < this.$store.state.stepData.titles.length) {
                return this.$store.state.stepData.titles[nextIndex].answered;
            }
            return false;
        },
        isAnswerMax: function () {
            return this.$store.state.isAnswerMax;
        },
        images: function () {
            return this.$store.state.quizData.images;
        },
        currentStepPosition: function () {
            if (this.isResultsPage) {
                return this.$store.state.stepData.titles.length + 1;
            }
            let currentStepPosition = 0;
            forIn(this.$store.state.stepData.titles, (step) => {
                if (step.id === this.question.id) {
                    currentStepPosition = step.orderNr;
                }
            });
            return currentStepPosition;
        },
        progressBarStyle() {
            return {
                "--currentStepPosition": this.currentStepPosition,
                "--nbSteps": this.$store.state.stepData.titles.length + 1,
            };
        },
        stepSelectionText: function () {
            return this.$store.state.quizData.translations.stepTitleSelection;
        },
    },
    updated() {
        if (
            this.question.type !== "number" &&
            this.question.type !== "text" &&
            this.quizData.renderingType === "accordion" &&
            this.nextButtonDisabled === false &&
            this.quizData.accordionGoToNextQuestion === true
        ) {
            if (this.question.type === "multiple") {
                if (this.isAnswerMax === true) {
                    this.skipQuestion();
                }
            } else {
                this.skipQuestion();
            }
        }
    },
    methods: {
        prevQuestion: function () {
            if (this.isResultsPage) {
                this.$store.dispatch("gotoQuestion", this.question.id);
            }
            else if (this.question.prevQuestion && this.question.prevQuestion != "") {
                this.$store.dispatch("prevQuestion", this.question.prevQuestion);
            } else {
                this.$store.dispatch("loadInitialQuestion", { qid: this.quizData.quizid, reset: false });
            }
        },
        skipQuestion: function () {
            if (this.nextButtonDisabled) {
                return;
            }

            let data = {
                quizid: this.quizData.quizid,
                qid: this.question.id,
                aid: [""],
            };
            this.$store.dispatch("submitQuestion", data);
        },
        startOver: function () {
            this.$store.dispatch("loadInitialQuestion", { qid: this.quizData.quizid, reset: true });
        },
    },
};
</script>
